import { TABLE } from '../actions/actionTypes';

export const selectTable = (formId) => (
  { type: TABLE.SELECT_TABLE, formId }
);
